import React from 'react'
import Lottie from "react-lottie";
import "./Waiting.css"
import * as animationData from './waiting.json';

const Waiting = () => {
    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: animationData,
        rendererSettings: {
            preserveAspectRatio: "xMidYMid slice"
        }
    };
    return (
        <>
            <section className='main-lottey'>
                <div className='waiting mx-auto'>
                    <Lottie
                        options={defaultOptions}
                    />
                </div>
            </section>
        </>
    )
}

export default Waiting